export default __webpack_public_path__ + "static/media/celcom-chat-info-icon.d2d975e3.svg";